const Routes_gral = {
    login: '/',
    home: '/Home',
    user: '/User',
    group: '/Group',
    product: '/Product',
    addReq: '/addReq',
    reqSector: '/reqSector',
    subcuentas: '/subcuentas',
}

export default Routes_gral